import { render, staticRenderFns } from "./pictureQuestion.vue?vue&type=template&id=c6d29810&scoped=true&"
import script from "./pictureQuestion.vue?vue&type=script&lang=js&"
export * from "./pictureQuestion.vue?vue&type=script&lang=js&"
import style0 from "./pictureQuestion.vue?vue&type=style&index=0&id=c6d29810&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6d29810",
  null
  
)

export default component.exports